import React from "react";

function SearchSteps({ steps, isSearching }) {
  if (!steps || steps.length === 0) return null;

  return (
    <div className="flex flex-col gap-y-[6px] mb-[12px]">
      {steps.map((step, i) => (
        <div
          key={i}
          className="flex items-start gap-x-[8px] text-[15px] font-body font-semibold animate-fadeIn"
          style={{ animationDelay: `${i * 150}ms`, animationFillMode: "both" }}
        >
          <span className="text-dupontGold dark:text-darkGold mt-[1px] shrink-0">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </span>
          <span className="text-dupontBlue/80 dark:text-darkText/70">
            {step.action}
            {step.result && (
              <span className="text-dupontBlue/55 dark:text-darkText/50">
                {" — "}
                {step.result}
              </span>
            )}
          </span>
        </div>
      ))}
      {isSearching && (
        <div className="flex items-center gap-x-[8px] text-[15px] font-body font-semibold text-dupontGold dark:text-darkGold animate-pulse">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <span>Searching...</span>
        </div>
      )}
    </div>
  );
}

export default SearchSteps;
